var _path, _path2, _path3, _path4, _path5, _path6, _path7, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgCart(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.375 37.5C12.65 37.5 11.25 36.1 11.25 34.375C11.25 32.65 12.65 31.25 14.375 31.25C16.1 31.25 17.5 32.65 17.5 34.375C17.5 36.1 16.1 37.5 14.375 37.5ZM14.375 33.75C14.025 33.75 13.75 34.025 13.75 34.375C13.75 34.725 14.025 35 14.375 35C14.725 35 15 34.725 15 34.375C15 34.025 14.725 33.75 14.375 33.75Z",
    fill: "url(#paint0_linear_149_22)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M31.875 37.5C30.15 37.5 28.75 36.1 28.75 34.375C28.75 32.65 30.15 31.25 31.875 31.25C33.6 31.25 35 32.65 35 34.375C35 36.1 33.6 37.5 31.875 37.5ZM31.875 33.75C31.525 33.75 31.25 34.025 31.25 34.375C31.25 34.725 31.525 35 31.875 35C32.225 35 32.5 34.725 32.5 34.375C32.5 34.025 32.225 33.75 31.875 33.75Z",
    fill: "url(#paint1_linear_149_22)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M35 32.5H12.3375C10.3375 32.5 9.15 30.275 10.2625 28.6125L11.4625 26.8125C12.375 25.4375 14.4625 26.8125 13.5375 28.2L12.3375 30.0125H35C36.65 30.0125 36.65 32.5125 35 32.5125V32.5Z",
    fill: "url(#paint2_linear_149_22)"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M7.63751 14.3125L6.73751 12.5H3.75001C2.10001 12.5 2.10001 10 3.75001 10H7.50001C7.97501 10 8.41251 10.2625 8.61251 10.6875L9.86251 13.1875C10.6 14.6625 8.36251 15.7875 7.62501 14.3L7.63751 14.3125Z",
    fill: "url(#paint3_linear_149_22)"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M36.1875 11.25L8.6875 12.5C7.8875 12.5375 7.325 13.3 7.5375 14.075L11.2875 27.825C11.4375 28.375 11.9375 28.75 12.4875 28.75H12.5625L32.5625 27.5C33.1 27.4625 33.55 27.1 33.6875 26.5875L37.4375 12.8375C37.6625 12.0375 37.0375 11.2375 36.175 11.2625L36.1875 11.25Z",
    fill: "url(#paint4_linear_149_22)"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M22.5 22.5C28.0228 22.5 32.5 18.0228 32.5 12.5C32.5 6.97715 28.0228 2.5 22.5 2.5C16.9772 2.5 12.5 6.97715 12.5 12.5C12.5 18.0228 16.9772 22.5 22.5 22.5Z",
    fill: "#00B074"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M20.3625 15.8875L17.8625 13.3875C16.6875 12.2125 18.4625 10.45 19.625 11.625L21.2375 13.2375L25.35 9.125C26.525 7.95 28.2875 9.725 27.1125 10.8875L22.1125 15.8875C21.625 16.375 20.8375 16.375 20.35 15.8875H20.3625Z",
    fill: "white"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_149_22",
    x1: 12.1625,
    y1: 36.5875,
    x2: 16.5875,
    y2: 32.1625,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00E676"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#69F0AE"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_149_22",
    x1: 29.6625,
    y1: 36.5875,
    x2: 34.0875,
    y2: 32.1625,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00E676"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#69F0AE"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_149_22",
    x1: 15.9625,
    y1: 37.1625,
    x2: 29.3375,
    y2: 23.8,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#004D40"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#26A69A"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_149_22",
    x1: 4.72501,
    y1: 14.0125,
    x2: 8.37501,
    y2: 10.3625,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#004D40"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#26A69A"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_149_22",
    x1: 11.925,
    y1: 28.7,
    x2: 33.075,
    y2: 7.55,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00E676"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#69F0AE"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCart);
export default __webpack_public_path__ + "static/media/Cart.50fa366eefc3d2dd5b12ce9dc627ebf4.svg";
export { ForwardRef as ReactComponent };